import React from "react";
import { Router } from "react-router-dom";
import DevTools from "mobx-react-devtools";
import { hydrate } from "emotion";
import { Provider as MobxProvider } from "mobx-react";
import RootStore from "./src/store";

import lazySizes from "lazysizes";

exports.replaceRouterComponent = ({ history }) => {
  const ConnectedRouterWrapper = ({ children }) => (
    <MobxProvider store={new RootStore()}>
      <Router history={history}>{children}</Router>
    </MobxProvider>
  );

  return ConnectedRouterWrapper;
};

exports.onClientEntry = () => {
  if (typeof window !== "undefined") {
    lazySizes.init();
    // polyfill remove any elem in DOM
    if (!Element.prototype.remove) {
      Element.prototype.remove = function remove() {
        if (this.parentNode) {
          this.parentNode.removeChild(this);
        }
      };
    }
  }
  if (
    typeof window !== `undefined` &&
    typeof window.__EMOTION_CRITICAL_CSS_IDS__ !== `undefined`
  ) {
    hydrate(window.__EMOTION_CRITICAL_CSS_IDS__);
  }
};



// WEBPACK FOOTER //
// ./gatsby-browser.js